export type RefreshOutcome = "idle" | "loading" | "success" | "error";

export function getRefreshMessage(outcome: RefreshOutcome) {
  if (outcome === "loading") return "جارٍ تحديث المباريات...";
  if (outcome === "success") return "تم تحديث المباريات والمواعيد الآن.";
  if (outcome === "error") return "تعذر تحديث المباريات. حاول مرة أخرى.";
  return "";
}
